import { render } from "./write-in-button.vue?vue&type=template&id=0b1491d2"
import script from "./write-in-button.vue?vue&type=script&lang=js"
export * from "./write-in-button.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__